import {
    IAuthenticationAppRouterService
} from "../interfaces/authentication-app-router-service";

import { ICommonConfig } from "../../application/interfaces/common-config";
import {
    DestroyRef, inject
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import {
    take,
    switchMap
} from "rxjs";
import { ResourceBundleSearchFilterOptions } from "@shopliftr/common-js/shared";
import {
    ResourceBundle,
    LocalizationUtil
} from "@shopliftr/common-js/data";
import { ResourceBundleApiClientService } from "../services/api-client/resource-bundle/resource-bundle-api-client.service";
import { IAppService } from "../../application/interfaces/app-service";
import { COMMON_APP_SERVICE } from "../../application/constants/app-tokens";
import { NotificationType } from "../../notification/enums/notification-type.enum";

/**
 * When the user is logged in the first time, this retrieves the Resource Bundles and initializes LocalizationUtil with them.
 *
 * This is called when the application is bootstrapped
 *
 * If it fails to retrieve the Resource Bundles the User will be logged out and an appropriate message will be displayed
 */
export const localizationUtilInitializer = (): void => {

    const app = inject(COMMON_APP_SERVICE) as IAppService<ICommonConfig, IAuthenticationAppRouterService>;
    const resourceBundleService = inject(ResourceBundleApiClientService);
    const destroyRef = inject(DestroyRef);
    app.authService.validToken$.pipe(
        // Retrieve the resource bundles from internal API
        switchMap(() => resourceBundleService.getAll$(new ResourceBundleSearchFilterOptions().setDefaults())),
        // Complete the subscription after 1 execution
        take(1),
        takeUntilDestroyed(destroyRef)
    ).subscribe({
        next: (bundles: Array<ResourceBundle>) => LocalizationUtil.initialize(bundles),
        error: (error: unknown) => {
            app.errorHandler.handleInitializerError(error, "Failed to initialize LocalizationUtil");
            app.appRouter.toLogout();
            app.authService.handleLogout({
                type: NotificationType.Error,
                message: "Unable to initialize the application. Refresh your browser and try again. If the problem persists contact support."
            });
        }
    });
};
